// IE 2026 10 25 / ODOO-348878 (заказ Игоря: высота строк после «свернуть все»): массовая свёртка строк AttrGrid (collapseGroupsToLevel внутри deferUpdate — бейджи угла,
// меню строки «до уровня» / «развернуть всё», панель группировки) — groupCollapsedChanged приходит на каждую строку при flex.isUpdating и раньше отбрасывался целиком:
// высоты начал секций (+зазор) оставались от прежней свёртки. Здесь — чистые функции: выключатель, решение на событие, один отложенный пересчёт на пачку событий.
// Выключатель fe.ux.gridCollapseAllHeights (§8, дефолт ВКЛ)
export const GCA_FLAG = 'fe.ux.gridCollapseAllHeights'
export function gcaOn(setting) {
    try { return (typeof setting === 'function' ? setting(GCA_FLAG, true) : true) !== false } catch (e) { return true }
}
// решение на событие свёртки: 'skip' — нечего делать (нет грида, печать); 'now' — одиночная (прежний путь groupCollapsedChanged);
// 'bulk' — массовая у грида с секциями при включённом выключателе (on — значение или функция, читается только для массовой)
export function gcaPlan({ hasFlex = true, isUpdating = false, print = false, delivery = true, on = true } = {}) {
    if (!hasFlex || print) return 'skip'
    if (!isUpdating) return 'now'
    if (!delivery) return 'skip'
    let v = true
    try { v = typeof on === 'function' ? on() : on } catch (e) { v = true }
    return v !== false ? 'bulk' : 'skip'
}
// один пересчёт на пачку событий: первое ставит микрозадачу (после синхронного deferUpdate, до отложенной отрисовки), прочие — no-op;
// к запуску грид ещё в обновлении — повтор через later, не больше maxTries, затем run всё равно. Возврат: поставлено ли
export function gcaSchedule(st, { isUpdating = () => false, run, micro = (f) => Promise.resolve().then(f), later = (f) => setTimeout(f, 0), maxTries = 20 } = {}) {
    if (!st || st.queued || typeof run !== 'function') return false
    st.queued = true
    let tries = 0
    const go = () => {
        let busy = false
        try { busy = !!isUpdating() } catch (e) { busy = false }
        if (busy && tries < maxTries) { tries++; later(go); return }
        st.queued = false
        try { run() } catch (e) { /* грид разобран */ }
    }
    micro(go)
    return true
}
